// Hook que wrappea la RPC marcar_mensajes_leidos. Idempotente —
// se puede llamar repetidamente, solo afecta mensajes con read_at IS NULL.
//
// Patrón de uso típico: llamarlo al montar la conversación (efecto on
// pacienteId change). El callback no requiere await — se dispara
// fire-and-forget; el caller no necesita el resultado.

import { useCallback } from "react";
import { supabase } from "../client";

export interface UseMarcarLeidosReturn {
  marcar: (pacienteId: string) => Promise<number>;
}

export function useMarcarLeidos(): UseMarcarLeidosReturn {
  const marcar = useCallback(async (pacienteId: string): Promise<number> => {
    const { data, error } = await supabase.rpc("marcar_mensajes_leidos", {
      p_paciente_id: pacienteId,
    });
    if (error) {
      console.warn("[useMarcarLeidos] rpc error", error);
      return 0;
    }
    if (data && data.ok) {
      return (data.updated as number) ?? 0;
    }
    return 0;
  }, []);

  return { marcar };
}
